export default "__VITE_ASSET__lEUwK12p__"